<cm-test-container [testCases]="testCases">
    <div class="cm-setup-hint">
        <p class="cm-setup-intro">
            These pages embed the configurator from <code>configurator.colormass.com</code>. To exercise your local build, add the two
            <a href="https://requestly.com/" target="_blank" rel="noopener">Requestly</a> rules below, then click a page (opens in a new tab). On the target
            page, Requestly will show a small popup when a rule was applied.
        </p>

        <div class="cm-rule">
            <h3>Rule 1 — Redirect Request</h3>
            <ul>
                <li>If "URL" matches "wildcard": <code>https://configurator.colormass.com/*</code></li>
                <li>Redirects to: <code>http://localhost:4300/$1</code></li>
            </ul>
        </div>

        <div class="cm-rule">
            <h3>Rule 2 — Modify Response Headers (remove)</h3>
            <ul>
                <li><code>Content-Security-Policy</code></li>
                <li><code>Content-Security-Policy-Report-Only</code></li>
            </ul>
        </div>
    </div>
</cm-test-container>
